


























































import Vue from "vue";
import { Component, Ref, Prop, Watch } from "vue-property-decorator";
import User from "@/services/User";

@Component
export default class ChangePasswordDialog extends Vue {
  @Prop({ required: true }) value = false;
  @Ref("form") readonly formRef!: HTMLFormElement;

  valid = false;
  form = {
    username: "",
    email: "",
    oldPassword: "",
    newPassword: "",
    confirmPassword: ""
  };
  showOld = false;
  showNew = false;
  showConfirm = false;
  rules = {
    required: (v: string) => !!v || "Field harus diisi",
    email: (v: string) => /.+@.+\..+/.test(v) || "Format email tidak valid",
    passwordComplex: (v: string) =>
      /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(v) ||
      "Password minimal 8 karakter dan kombinasi huruf & angka",
    matchPassword: (v: string) =>
      v === this.form.newPassword || "Konfirmasi tidak cocok"
  };
  saving = false;

  get dialog() {
    return this.value;
  }
  set dialog(val) {
    this.$emit("input", val);
  }

  get params() {
    return {
      email: this.form.email,
      username: this.form.username,
      old_password: this.form.oldPassword,
      new_password: this.form.newPassword
    };
  }

  @Watch("dialog")
  changeDialog(val) {
    if (!val) {
      this.reset();
    }
  }

  submit(): void {
    if (this.$refs.form && (this.$refs.form as any).validate()) {
      if (!this.saving) {
        this.saving = true;
        User.statelessChangePassword(this.params)
          .then(resp => {
            if (resp.status) {
              alert(resp.message);

              this.reset();
              this.closeDialog();
            } else {
              alert(resp.message);
            }
          })
          .catch(err => {
            console.log("err", err);
            if (err.response) {
              alert(`ERR${err.response.status}: ${err.response.data.message}`);
            }
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }

  closeDialog(): void {
    this.dialog = false;
  }

  reset() {
    this.form = {
      username: "",
      email: "",
      oldPassword: "",
      newPassword: "",
      confirmPassword: ""
    };
  }
}
